import { makeStyles } from '@material-ui/core/styles'

import map from '../assets/map.png'

export const cardStyles = makeStyles(() => ({
    bg: {
        backgroundImage: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${map})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        minWidth: 'calc(30vw * 0.54 - 2%)',
        height: '30vh',
        borderRadius: 8,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        margin: '15px',
    },
    eRoomCard: {
        width: 330,
        height: 330,
        borderRadius: 20,
        padding: 0,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        margin: '15px',
    },
    eRoomCardCreate: {
        width: 330,
        height: 250,
        borderRadius: 20,
        padding: 0,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        margin: '15px',
    },
    wrapperER: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '0 40px'
    },
    editIconWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    cardContentWrapper: {
        padding: 20,
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '10px !important'
    },
    iconsWrapper: {
        display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '0 50px', maxWidth: '70%'
    },
    timeWrapper: {
        fontSize: 16,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white'
    },
    totalTime: {
        color: 'white', fontSize: 16, paddingRight: 5,
    },
    remainingTime: {
        color: 'red', fontSize: 16, paddingRight: 5, paddingLeft: 5
    },
    editWrapper: {
        display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'
    },
    icon: {
        color: 'white', fontSize: 16, cursor: 'pointer'
    },
    createCard: {
        borderWidth: 1, borderStyle: 'solid', borderRadius: 20, minHeight: '100%'
    },
    createBtn: {
        color: '#33949E', fontSize: 80, cursor: 'pointer'
    },
    descriptionText: {
        width: 250,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        margin: 0,
        background: 'white'

    }

}))
